/** moderator/evaluations — API. */
import { http } from '../../_shared/http';
import type { EvaluationResult } from './types';

const seg = encodeURIComponent;

export const evaluationsApi = {
  run: (gameName: string, worldName: string, cohortId: string, matchFolder: string) =>
    http.post<EvaluationResult>(`/evaluations/${seg(gameName)}/${seg(worldName)}/${seg(cohortId)}/run`, { matchFolder }),

  get: (gameName: string, worldName: string, cohortId: string, matchFolder: string) =>
    http.get<EvaluationResult>(`/evaluations/${seg(gameName)}/${seg(worldName)}/${seg(cohortId)}/${seg(matchFolder)}`),
};
